// За полной документацией по API, включая примеры кода, зайдите на http://wix.to/94BuAAs

$w.onReady(function () {<meta name="google-site-verification" content="q-HDuOtSU05QKptdi31d3X1zLnClvF7qGT3V3l7oFcE" />
	//TODO: write your page related code here...

});